import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

import FilesList from './FilesList';

export default function FilesDialog(props) {
  const theme = useTheme();
  const {
    fileDialog = false,
    upload_type,
    prefix,
    itemName,
    setFileDialog,
  } = props;

  const handleDialogClick = e => {
    e.stopPropagation();
  };

  return (
    <Dialog fullScreen open={fileDialog} onClick={handleDialogClick}>
      <DialogContent>
        <FilesList
          upload_type={upload_type}
          name={itemName}
          default_prefix={prefix}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setFileDialog(false)}
          variant="contained"
          style={{ backgroundColor: theme.palette.error.main }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
